<template>
  <div class="inter-wrap" v-show="isShowAnswerCard">
    <div class="inter-mask"></div>
    <div class="inter-modal">
      <div class="inter-info">
        <div class="inter-head">
          <div class="inter-tit">答题卡</div>
          <div><img @click="onSetAnswerCardVisible(false)" :src="closeImg" alt="" /></div>
        </div>
        <answer-card
          :answer-card-sdk="answerCardSdk"
          @to-show="onSetAnswerCardVisible(true)"
          @to-hide="onSetAnswerCardVisible(false)"
          @status-changed="onStatusChanged"
        />
      </div>
    </div>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
import { AnswerCard as AnswerCardSDK } from '@polyv/interactions-receive-sdk'
import AnswerCard from '@polyv/interactions-receive-sdk-ui-default/lib/PcAnswerCard/index'
import closeImg from '@/assets/icons/close.png'
export default {
  name: '',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isImage: false,
      closeImg,
      answerCardSdk: null, // 答题卡SDK实例
      isShowAnswerCard: false, // 是否显示答题卡
      answerCardTitle: '', // 外部弹窗（容器）标题
    }
  },
  components: {
    zModal,
    AnswerCard,
  },
  async created() {
    this.initPolyIr()
  },
   beforeDestroy() {
    this.answerCardSdk.destroy()
  },
  methods: {
    initPolyIr() {
     // const { AnswerCard } = window.PolyvIRSDK
      this.answerCardSdk = new AnswerCardSDK()
      this.answerCardSdk.on(this.answerCardSdk.events.GET_TEST_QUESTION_CONTENT, function (msg) {
        console.log('接收到答题开始事件', msg, '题目：', msg.name, '题目限时：', msg.duration)
      })
    },
    onSetAnswerCardVisible(visible) {
      this.isShowAnswerCard = visible
      console.log('this.isShowAnswerCard', this.isShowAnswerCard)
    },

    onStatusChanged(status) {
      if (status === 'isShowResult' || status === 'isShowAnswer') {
        this.answerCardTitle = this.answerCardSdk.curSubmittedAnswer ? '答题结果' : '未作答'
      } else {
        this.answerCardTitle = '答题卡'
      }
    },
  },
}
</script>
<style lang="less" scoped>
.inter-wrap {
  z-index: 999;
  width: 100%;
}
.inter-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  filter: alpha(opacity=50);
}
.inter-info {
  width: 600px;
  background-color: #fff;
  position: absolute;
  top: 100px;
  margin: 0 auto;
  z-index: 99999;
  border-radius: 10px;
}
.inter-modal {
  display: flex;
  align-content: center;
  justify-content: center;
}
.inter-head {
  display: flex;
  justify-content:space-between;
  padding: 20px;
}
.inter-head img {
  width: 12px;
  height: 12px;
}
.inter-tit {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}
</style>
